import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { Deployment } from 'src/app/models/deploy/deployment';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-confirm-deploy-instance-dialog',
    templateUrl: './confirm-deploy-instance-dialog.component.html',
    styleUrls: ['./confirm-deploy-instance-dialog.component.scss'],
    standalone: false
})
export class ConfirmDeployInstanceDialogComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;
  @Input() deployment: Deployment;
  @Input() requestDescription: string;
  @Input() maintenanceWindow: any;

  Object = Object;

  moment = moment;

  dayOfTheWeek: string;

  constructor(public sidenavService: SidenavService) { }

  ngOnInit(): void {
    this.dayOfTheWeek = moment.weekdays()[this.maintenanceWindow.dayOfTheWeek];
  }

  confirmDeploy(): void {
    this.sidenavService.closeRightSidenav(this.deployment);
  }
}
